import { FC } from 'react';
import { Action, Label, TableBody, TableHeader, TableRow } from '../../atoms';
import { Table } from '../../molecules';
import { LandscapeCommodityResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-commodity-response.dto';

export interface LandscapeCommoditiesOrganismProps {
  content: LandscapeCommodityResponseDto[];
  handleEdit: (id: string) => void;
  handleDelete: (id: string) => void;
}

const LandscapeCommoditiesOrganism: FC<LandscapeCommoditiesOrganismProps> = ({
  content,
  handleEdit,
  handleDelete,
}) => {
  return (
    <Table>
      <TableHeader>
        <TableRow header={true}>
          <Label bold content="Commodities" />
          <Label bold content="Qty" />
          <Label bold content="QtyUnit" />
          <Label bold content="Time" />
          <Label bold content="TimeUnit" />
          <Label bold content="Available" />
          <Label />
          <Label />
        </TableRow>
      </TableHeader>
      <TableBody>
        {content.map((item: LandscapeCommodityResponseDto) => (
          <TableRow key={item.id}>
            <Label content={item.name} />
            <Label content={item.qty?.toString()} />
            <Label content={item.qtyUnit} />
            <Label content={item.time?.toString()} />
            <Label content={item.timeUnit} />
            <Label content={item.availabilityType} />
            <Action type="edit" size="sm" onClick={() => handleEdit(item.id)} />
            <Action
              type="delete"
              size="sm"
              onClick={() => handleDelete(item.id)}
            />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default LandscapeCommoditiesOrganism;
